
import { SONGS as RAW_SONGS } from '../audio/songs';
import { Song } from '../types/common';

const SONG_METADATA: Record<string, { genre: string, vibe: string }> = {
    'HOW_ITS_DONE': { 
        genre: 'K-pop Dance / Hip-hop', 
        vibe: 'High-energy, confident K-pop anthem with rap-driven punch.' 
    },
    'YOUR_IDOL': { 
        genre: 'K-pop Pop / Theatrical', 
        vibe: 'Dark, dramatic, hypnotic pop with theatrical intensity.' 
    },
    'SODA_POP': { 
        genre: 'K-pop Pop / Upbeat Dance', 
        vibe: 'Bubbly, cheerful, playful pop that’s instantly catchy.' 
    },
    'FREE': { 
        genre: 'K-pop Ballad / Emotional Pop', 
        vibe: 'Emotional, heartfelt duet with a gradual, uplifting build.' 
    },
    'WHAT_IT_SOUNDS_LIKE': { 
        genre: 'K-pop Ballad / Inspirational Pop', 
        vibe: 'Reflective, inspirational pop ballad with mid-tempo crescendos.' 
    },
    'WILL_HE_LET_THE_FIRE_GO_OUT': { 
        genre: 'Acoustic / Storytelling', 
        vibe: 'Intimate, stripped-down acoustic storytelling.' 
    },
    'APT': { 
        genre: 'Pop / Pop Rock / New Wave', 
        vibe: 'Playful, upbeat pop-rock/pop-punk with chant-driven hooks.' 
    },
    'TAKEDOWN': {
        genre: 'K-pop Trap / Diss Track',
        vibe: 'Aggressive, confrontational K-pop diss track built for intensity and conflict.'
    },
    'GOLDEN': {
        genre: 'K-pop Anthem / Pop',
        vibe: 'Anthemic, aspirational K-pop pop that feels triumphant and self-defining.'
    }
};

// Map HuntrixSong (Audio Data) to Song (Game/UI Data)
export const SONGS: Song[] = RAW_SONGS.map(s => ({
    id: s.id,
    title: s.title,
    bpm: s.musicalData.bpm,
    genre: SONG_METADATA[s.id]?.genre || 'K-Pop',
    vibe: SONG_METADATA[s.id]?.vibe || 'Unique sound.',
    structure: s.structure.map(sec => ({
        type: sec.type,
        lyrics: sec.lyrics,
        // Convert Beats to Seconds: (Beats / BPM) * 60
        duration: (sec.duration / s.musicalData.bpm) * 60,
        rhythm: sec.rhythm
    }))
}));
